import { Component, Input } from "@angular/core";

@Component({
  selector: "menu-principal",
  template: `
    <ion-buttons>
      <ion-menu-toggle [menu]="menu">
        <ion-button>
          <ion-icon name="menu" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-menu-toggle>
    </ion-buttons>
  `,
})
export class MenuPrincipalComponent {
  @Input() menu: string;
}
